import gql from 'graphql-tag';
import { ProductAllData } from '../fragments';

export default gql`
query Product(
    $getBy: getProductBy!
    $value: String!
) {
    product(
        getBy: $getBy,
        value: $value
    ) {
       ...ProductAllData
    }
}
${ProductAllData}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/product.ts